import { apiFetch } from "./auth";

export async function getRealisations(search = "") {
  const url = search ? `/api/realisations?search=${encodeURIComponent(search)}` : "/api/realisations";
  const res = await apiFetch(url);

  const text = await res.text();
  let data;
  try { data = JSON.parse(text); } catch { data = null; }

  if (!res.ok) {
    throw new Error(data?.error || `Erreur API (${res.status}) : ${text.slice(0, 80)}...`);
  }

  return Array.isArray(data?.items) ? data.items : [];
}

export async function createRealisation(payload) {
  const res = await apiFetch("/api/realisations", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Erreur création");
  return data?.item || data;
}

export async function updateRealisation(id, payload) {
  const res = await apiFetch(`/api/realisations/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Erreur modification");
  return data?.item || data;
}

export async function deleteRealisation(id) {
  const res = await apiFetch(`/api/realisations/${id}`, { method: "DELETE" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || "Erreur suppression");
  return true;
}
